import { render, staticRenderFns } from "./BankId.vue?vue&type=template&id=cc8da6f4&scoped=true&"
import script from "./BankId.vue?vue&type=script&lang=js&"
export * from "./BankId.vue?vue&type=script&lang=js&"
import style0 from "./BankId.vue?vue&type=style&index=0&id=cc8da6f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8da6f4",
  null
  
)

export default component.exports